import { render } from "./CreativeCreate.vue?vue&type=template&id=fb71d0d4"
import script from "./CreativeCreate.vue?vue&type=script&lang=js"
export * from "./CreativeCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__